/**
 * Returns an object which properties represent the corresponding property name.
 * It's a very simple "nameOf()" replacement.
 *
 * @remarks
 * Part of synergy/utils
 * See https://stackoverflow.com/a/63891494
 *
 * @type T - The Type to extract the properties
 * @returns an object with string mapped properties of the provided type
 *
 */
export function fields<T>() {
    return new Proxy(
        {},
        {
            get: function (_target, prop, _receiver) {
                return prop;
            },
        }
    ) as {
        [P in keyof T]-?: P;
    };
}
